import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Target, ChevronRight } from "lucide-react";
import { dailyApi, getToken } from "../lib/api";

const TONE = {
  alert: "border-[#334155] border-l-4 border-l-[#10B981] bg-[#1E293B]",
  wait: "border-[#334155] bg-[#1E293B]",
  win: "border-[#334155] border-l-4 border-l-[#38BDF8] bg-[#1E293B]",
  done: "border-[#1E293B] bg-[#1E293B]/60 opacity-80",
};

const timeLeft = (exp) => {
  const s = exp - Date.now() / 1000;
  if (!exp || s <= 0) return null;
  const h = Math.floor(s / 3600);
  return h >= 1 ? `${h}h left` : `${Math.max(1, Math.floor(s / 60))}m left`;
};

// "Your open clashes": live wagers, mates who accepted, rematch invites and recent results.
const OpenClashes = ({ refreshKey }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = () => getToken() && dailyApi.clashes().then((d) => setItems(d.clashes)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [refreshKey]);

  if (!items.length) return null;
  return (
    <div data-testid="open-clashes" className="mt-8 w-full text-left fade-up">
      <div className="flex items-center gap-3 mb-2.5"><h2 className="font-display font-bold uppercase text-lg tracking-wide">Your open clashes</h2><span className="h-px flex-1 bg-[#334155]" /></div>
      <div className="space-y-2">
        {items.map((c) => {
          const Icon = c.kind === "draft" ? Users : Target;
          const left = c.label === "Waiting for a mate" ? timeLeft(c.expires_at) : null;
          return (
            <button key={`${c.kind}-${c.id}`} data-testid={`clash-${c.id}`} onClick={() => navigate(c.link)}
              className={`w-full flex items-center gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors hover:border-[#475569] ${TONE[c.tone]}`}>
              <Icon className="w-4 h-4 text-[#38BDF8] shrink-0" />
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold truncate">{c.label}</span>
                <span className="block text-[11px] text-slate-400">
                  {c.kind === "draft" ? "Draft XI" : "Penalty Shootout"} · {c.stake ? `£${c.stake}` : "Friendly"}{left ? ` · ${left}` : ""}
                </span>
              </span>
              <span className={`text-xs font-bold flex items-center shrink-0 ${c.tone === "alert" ? "text-[#10B981]" : "text-slate-300"}`}>
                {c.cta} <ChevronRight className="w-4 h-4" />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OpenClashes;
